import { supabase } from '@/lib/supabase';
import { adminLog, adminError } from '@/lib/utils/admin-logger';

/**
 * Cleans up an orphaned file from storage when paper creation fails
 * @param fileUrl The public URL of the file to delete
 * @param userId The ID of the user who uploaded the file
 */
export async function cleanupOrphanedFile(fileUrl: string, userId: string): Promise<void> {
  try {
    // Extract file path from URL
    // URL format: https://.../storage/v1/object/public/papers/user_id/...
    const urlParts = fileUrl.split('/');
    const papersIndex = urlParts.indexOf('papers');
    
    if (papersIndex === -1) {
      adminError('Invalid file URL format for cleanup:', fileUrl);
      return;
    }
    
    const filePath = urlParts.slice(papersIndex + 1).join('/');
    
    adminLog(`Cleaning up orphaned file: ${filePath} for user ${userId}`);
    
    const { error } = await supabase.storage
      .from('papers')
      .remove([filePath]);
    
    if (error) {
      adminError('Failed to cleanup orphaned file:', error);
    } else {
      adminLog('Successfully cleaned up orphaned file');
    }
  } catch (error) {
    adminError('Error during file cleanup:', error);
  }
}
